import React, { useState } from 'react';
import { Grid, makeStyles, Tabs, Tab } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Close } from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';
import CustomButtonIcon from '../../Common/ButtonIcon';
import EventTourInfo from '../TourInfo';
import AllMyEvents from '../MyEvents';
import TabPanel from '../../Common/TabPanel';
import ValidateUser from '../../UserStatus';

const EventTourDrawer = props => {
  const useStyles = makeStyles({
    eventTour: {
      display: 'flex',
      padding: '10px',
      justifyContent: 'center',
      alignItems: 'center',
    },
    eventTourClose: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '10px',
    },
    divider: {
      paddingTop: '0px !important',
    },
    normalLabel: {
      color: '#494949',
    },
    selectedLabel: {
      color: '#5E176A',
      fontWeight: '600',
    },
    normalContainer: {
      margin: '0px 5px 5px 5px !important',
      '&:hover': {
        backgroundColor: '#E9E9E98C',
      },
      paddingTop: '5px',
      borderRadius: '5px',
    },
    selectedContainer: {
      margin: '0px 5px 5px 5px !important',
      backgroundColor: '#F6EBF8',
      borderRadius: '5px',
    },
    loadingContent: {
      padding: '15px',
    },
    tabSet: {
      '& .MuiTab-root': {
        borderBottom: '1px solid #D9DDDF',
        minWidth: '100px',
        textTransform: 'none',
        fontSize: '14px',
      },
      '& .Mui-selected': {
        color: 'primary',
      },
    },
    tabSetDark: {
      '& .MuiTab-root': {
        borderBottom: '1px solid #D9DDDF',
        minWidth: '100px',
        textTransform: 'none',
        fontSize: '14px',
      },
      '& .Mui-selected': {
        color: '#E1BEE7',
      },
    },
  });
  const { eventMeta, action } = props;
  const [value, setValue] = useState(0);
  const [userSelected, setUserSelected] = useState({ type: '', user: '' });
  const classes = useStyles();
  const theme = useTheme();

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const handleClose = () => {
    // Reset tab selection and user selection so it can render the default when the user opens it again
    setUserSelected({ type: '', user: '' });
    setValue(0);
    action(false);
  };

  return (
    <>
      <ValidateUser />
      <Grid
        container
        style={{
          justifyContent: 'space-around',
          alignItems: 'center',
          paddingRight: '7px',
          paddingLeft: '5px',
        }}
      >
        <Grid item xs={11}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            aria-label="simple tabs example"
            className={theme.palette.type === 'light' ? classes.tabSet : classes.tabSetDark}
            TabIndicatorProps={{
              style: {
                height: '1px',
              },
            }}
          >
            <Tab label="Current Tour" />
            <Tab label="All Events" />
          </Tabs>
        </Grid>
        <Grid item xs={1}>
          <Grid container style={{ justifyContent: 'flex-start' }}>
            <CustomButtonIcon size="small" onClick={() => handleClose()} width="30px" height="30px" marginTop="0px">
              <Close />
            </CustomButtonIcon>
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
        <TabPanel value={value} index={0}>
          <EventTourInfo eventMeta={eventMeta} action={action} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AllMyEvents
            eventMeta={eventMeta}
            action={action}
            userSelected={userSelected}
            setUserSelected={setUserSelected}
          />
        </TabPanel>
      </Grid>
    </>
  );
};

EventTourDrawer.propTypes = {
  eventMeta: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
};

export default EventTourDrawer;
